import { get } from 'lodash';

/* istanbul ignore file */
export const getWorkingPeriods = (days: boolean[]): string[] => {
  let periods: string[] = [];
  let start = -1;

  for (let i = 0; i < days.length; i++) {
    if (days[i] && start === -1) {
      start = i + 1;
    } else if (!days[i] && start !== -1) {
      if (start === i) {
        periods.push(`${String(start).padStart(2, '0')}`);
      } else {
        periods.push(
          `${String(start).padStart(2, '0')} au ${String(i).padStart(2, '0')}`,
        );
      }
      start = -1;
    }
  }

  if (start !== -1) {
    if (start === 31) {
      periods.push(`${String(start).padStart(2, '0')}`);
    } else {
      periods.push(`${String(start).padStart(2, '0')} au 31`);
    }
  }

  return periods;
};

export const formatObject = (Obj: any) => {
  const filtered = Object.entries(Obj).filter(([key]) => key.startsWith('day'));

  const sorted = filtered.sort(([aKey], [bKey]) => {
    const aNum = parseInt(aKey.replace('day', ''), 10);
    const bNum = parseInt(bKey.replace('day', ''), 10);
    return aNum - bNum;
  });
  return Object.fromEntries(sorted);
};

const formatRanges = (ranges: any) => {
  return ranges.reduce(
    (acc: any, { start, end }: { start: number; end: number }) => {
      if (start === end) {
        acc.points.push(start);
      } else {
        acc.intervals.push({ start, end });
      }
      return acc;
    },
    { points: [], intervals: [] } as {
      points: number[];
      intervals: { start: number; end: number }[];
    },
  );
};

export const formatPayload = (ranges: any, jurisdictionId: any, data: any) => {
  const formatted = formatRanges(ranges);
  return [
    {
      jurisdictionId: jurisdictionId,
      lawyerCode: get(data, 'lawyerCode'),
      id: get(data, 'id'),
      ...formatted,
    },
  ];
};

export const formatPayloadToAdd = (
  ranges: any,
  jurisdictionId: any,
  selectedLawyer: any,
) => {
  const formatted = formatRanges(ranges);
  return [
    {
      jurisdictionId: jurisdictionId,
      lawyerCode: get(selectedLawyer, 'ItemKey'),
      ...formatted,
    },
  ];
};
